<template>
    <v-dialog
        v-model="drBenchDialog"
    >
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-toolbar-title>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-bottom-navigation
                    color="teal"
                    v-model="wind"
                    grow
                > 
                    <v-btn @click="wind = 1;">
                    <span >Driver</span>

                    <v-icon>mdi-gauge</v-icon>
                    </v-btn>

                    <v-btn @click="wind = 0;">
                    <span>Trailers</span>

                    <v-icon>mdi-train-car-tank</v-icon>
                    </v-btn>
                </v-bottom-navigation>
                <v-data-table
                    v-if="wind == 0"
                    :headers="headers"
                    :items="driver"
                    dense
                ></v-data-table>
                <v-data-table
                    v-else
                    :headers="headersTrailer"
                    :items="trailers"
                    dense
                ></v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
export default{
    props:['shiftId','drBenchDialog'],
    data:function () {
        return{
            wind:0,
            driver:[],
            trailers:[],
            headers:[
                {text:"Driver", value:"Driver"},
                {text:"Booked Cause", value:"BookedCauseDescription"},
                {text:"Booked Comments", value:"BookedComments"},
                
                {text:"BenchStart", value:"BenchStart"},
                {text:"BenchEnd", value:"BenchEnd"},
            ],
            headersTrailer:[
                { text: 'ID', value: 'id', width: '10%' },
                { text: 'Trailer', value: 'Trailer', width: '15%' },
                { text: 'NumAxles', value: 'NumAxles', width: '10%' }
            ]
        }
    },
    
    mounted() {
        this.loadCauses();
        this.loadTrailers();
    },
    methods:{
        loadCauses: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('bookedoff/driver/'+ this.shiftId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.driver = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadTrailers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('trailer/active/out-service', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trailers = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
    }
}
</script>